import { Injectable, Provider } from '@angular/core';

import { TimepickerModel, TimepickerModelAdapter } from '../../timepicker';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomTimepickerModelAdapter extends TimepickerModelAdapter<string> {
  fromModel(value: string | null): TimepickerModel | null {
    value = (value || '').trim();

    if (!value) {
      return null;
    }

    const { hours, minutes, meridiem } = this.parseToHoursMinutes(value);

    const addMeridiemHours =
      meridiem === 'PM'
        ? hours === 12
          ? 0
          : 12
        : meridiem === 'AM'
        ? hours === 12
          ? -12
          : 0
        : 0;

    const hours24Format = hours + addMeridiemHours;

    return {
      hours: hours24Format,
      minutes,
    };
  }

  toModel(model: TimepickerModel | null): string | null {
    if (!model || (model.hours == null && model.minutes == null)) {
      return '';
    }
    let { hours, minutes } = model || { hours: null, minutes: null };
    hours = hours || 0;
    minutes = minutes || 0;
    const meridiem = hours >= 0 && hours < 12 ? 'AM' : 'PM';
    const h = hours > 12 ? hours - 12 : hours === 0 ? 12 : hours;
    return `${h}:${minutes > 9 ? minutes : '0' + minutes} ${meridiem}`;
  }

  private parseToHoursMinutes(str: string) {
    str = (str || '').trim();

    const [hoursStr = '', minutesWithMeridiemStr = ''] = str.split(':');
    const [minutesStr = '', meridiemStr = ''] = minutesWithMeridiemStr.split(' ');

    const hours = hoursStr.length ? parseInt(hoursStr, 10) : null;
    const minutes = minutesStr.length ? parseInt(minutesStr, 10) : null;
    const meridiem = /A|AM/i.test(meridiemStr)
      ? 'AM'
      : /P|PM/i.test(meridiemStr)
      ? 'PM'
      : '';

    return { hours, minutes, meridiem };
  }
}

export const CustomTimepickerModelAdapterProvider: Provider = {
  provide: TimepickerModelAdapter,
  useClass: CustomTimepickerModelAdapter,
};
